import * as React from "react";
import { BooleanField, BooleanInput, TabbedForm, FormTab, FunctionField, Tab, TabbedShowLayout, EditButton, TopToolbar, DateField, Show, SimpleShowLayout, RichTextField, DateInput, Edit, List, Datagrid, TextField, EmailField, SimpleForm, TextInput, ReferenceInput, Create } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices
} from 'react-admin';

export const PrioritiesList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Display"  sortable={false}/>
            <TextField source="description"  sortable={false}/>
            <TextField source="seq" label="Sequence"/>
            <TextField source="priority" label="Priority" sortable={false}/>
            <TextField source="overDue" label="Consider Overdue After (hrs)"/>
            <BooleanField source="defaultValue" label="Default" sortable={false}/>
        </Datagrid>
    </List>
);



export const PrioritiesCreate = props => (
    <Create title="Create a new Dispatch Center" {...props}>
        <SimpleForm>

            <TextInput source="name" label="Display" validate={required()}/>
            <TextInput source="description" />
            <TextInput source="seq" label="Sequence"/>
            <TextInput source="priority" label="Priority" validate={required()}/>
            <TextInput source="overDue" label="OverDue" validate={required()}/>
            <BooleanInput source="defaultValue" label="Default"/>

        </SimpleForm>
    </Create>
);


export const PrioritiesEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
                        <TextInput source="name" label="Display" validate={required()}/>
                        <TextInput source="description" />
                        <TextInput source="seq" label="Sequence"/>
                        <TextInput source="priority" label="Priority" validate={required()}/>
                        <TextInput source="overDue" label="OverDue" validate={required()}/>
                        <BooleanInput source="defaultValue" label="Default"/>
        </SimpleForm>
    </Edit>
);
